module.exports = __webpack_public_path__ + "img/confernote_02.2bc0c1cf.png";